export const PageText = {
  _1: 'There is hope!',
  _2: 'Reducing your exposure to air pollution is effectively helping.'
};

export const Categories = {
  _1: {
    title: 'Rapid improvements',
    subcategories: [
      {
        key: 0,
        subtitle: 'Results of recent studies on this topic are impressive'
      }
    ],
    quotes: [
      {
        text: 'With decreasing (long-term) exposure to air pollution, lungs of e.g. children effectively become better again.',
        author: 'Gauderman, et al.',
        year: '2015'
      },
      {
        text: 'Reducing Personal Exposure to Particulate Air Pollution Improves Cardiovascular Health.',
        author: 'Langrish, et al.',
        year: '2012'
      },
      {
        text: 'Several studies show reductions in mortality following improvements in air quality. Three studies have observed substantial decreases in adult mortality after reductions in air pollution. In addition, this reduction has been shown in children, particularly with adequate air filtration or inhalation of less-polluted ambient air.',
        author: 'William & Kalpana',
        year: '2015'
      },
      {
        text: 'An improvement of the air quality directly leads to less heart infarcts & live expectance goes up with a half year.',
        author: 'De Standaard',
        year: '2017'
      },
      {
        text: 'The lower the levels of air pollution, the better the cardiovascular and respiratory health will be, both long- and short-term.',
        author: 'World Health Organisation'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/help-and-guides/there-is-hope_page.js